export default "__VITE_ASSET__DjsQUq8l__"